import React, { useEffect, useState } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import Dashboard from "./pages/Dashboard";
import Profile from "./pages/Profile";
import FeeManagement from "./pages/FeeManagement";
import PageResults from "./pages/PageResults";
import Attendance from "./pages/Attendance";
import StudentReport from "./pages/StudentReport";
import Profileparent from "./pages/Profileparent";
import MyChildren from "./pages/MyChildren";
import Student_school_darpan from "./pages/Student_school_darpan";
import PrivacyPolicy from "./pages/Privacy_Policy";
import Terms from "./pages/Terms";
import ContactUs from "./pages/ContactUs";
import FAQs from "./pages/FAQs";
import Loginpage from "./pages/Loginpage";
import Parentdashboard from "./pages/Parentdashboard";
import Prayas from "./pages/Prayas";
import School_Report_Dashbord from "./pages/School_Report_Dashbord";
import Staff_Report_Dashbord from "./pages/Staff_Report_Dashbord";
import Feedback from "./pages/Feedback";
import Student_window_hub from "./pages/Student_window_hub";
import Student_Report_Dashbord from "./pages/Student_Report_Dashbord";
import SchemeSearch from "./pages/SchemeSearch";
import Login from "./pages/Login";
import Parentlogin from "./pages/Parentlogin";
import Register from "./pages/Register";

import EducationLoader from "../src/pages/EducationLoader";

/* ---------------- Scroll To Top ---------------- */
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  }, [pathname]);

  return null;
}

/* ---------------- Loader Wrapper ---------------- */
/* Har page ke liye EducationLoader dikhata hai, phir actual page render karta hai */
function LoaderWrapper({ children }) {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => {
      setLoading(false);
    }, 800); // 0.8 sec loader time

    return () => clearTimeout(timer);
  }, []);

  return loading ? <EducationLoader /> : children;
}

/* ---------------- HOC: withLoader ---------------- */
/* Kisi bhi component ko loader ke saath wrap karne ke liye */
const withLoader = (Component) => {
  return function LoaderWrappedComponent(props) {
    return (
      <LoaderWrapper>
        <Component {...props} />
      </LoaderWrapper>
    );
  };
};

/* Loader ke saath wrapped pages */
const HomeWithLoader = withLoader(Home);
const DashboardWithLoader = withLoader(Dashboard);
const ProfileWithLoader = withLoader(Profile);
const FeeManagementWithLoader = withLoader(FeeManagement);
const PageResultsWithLoader = withLoader(PageResults);
const AttendanceWithLoader = withLoader(Attendance);
const StudentReportWithLoader = withLoader(StudentReport);
const ProfileparentWithLoader = withLoader(Profileparent);
const MyChildrenWithLoader = withLoader(MyChildren);
const StudentSchoolDarpanWithLoader = withLoader(Student_school_darpan);
const PrivacyPolicyWithLoader = withLoader(PrivacyPolicy);
const TermsWithLoader = withLoader(Terms);
const ContactUsWithLoader = withLoader(ContactUs);
const FAQsWithLoader = withLoader(FAQs);
const LoginpageWithLoader = withLoader(Loginpage);
const ParentdashboardWithLoader = withLoader(Parentdashboard);
const PrayasWithLoader = withLoader(Prayas);
const SchoolReportWithLoader = withLoader(School_Report_Dashbord);
const StaffReportWithLoader = withLoader(Staff_Report_Dashbord);
const FeedbackWithLoader = withLoader(Feedback);
const StudentHubWithLoader = withLoader(Student_window_hub);
const StudentReportDashWithLoader = withLoader(Student_Report_Dashbord);
const SchemeSearchWithLoader = withLoader(SchemeSearch);
const LoginWithLoader = withLoader(Login);
const ParentloginWithLoader = withLoader(Parentlogin);
const RegisterWithLoader = withLoader(Register);

/* ---------------- Layout ---------------- */
function Layout() {
  const location = useLocation();

  const currentPath = location.pathname.toLowerCase().replace(/\/$/, "");

  const hideNavbar = "";

  return (
    <div className="app">
      <ScrollToTop />

      {!hideNavbar && <Navbar />}

      <main>
        <Routes>
          {/* ---------- Pages with Loader ---------- */}
          <Route path="/" element={<HomeWithLoader />} />

          <Route
            path="/Student-school-darpan"
            element={<StudentSchoolDarpanWithLoader />}
          />

          <Route path="/Dashboard" element={<DashboardWithLoader />} />

          <Route path="/PrivacyPolicy" element={<PrivacyPolicyWithLoader />} />

          <Route path="/Terms" element={<TermsWithLoader />} />

          <Route path="/ContactUs" element={<ContactUsWithLoader />} />

          <Route path="/FAQs" element={<FAQsWithLoader />} />

          <Route path="/login-panels" element={<LoginpageWithLoader />} />

          <Route
            path="/Parentdash-board"
            element={<ParentdashboardWithLoader />}
          />

          <Route path="/Prayas" element={<PrayasWithLoader />} />

          <Route path="/School-Report" element={<SchoolReportWithLoader />} />

          <Route path="/Staff-Report" element={<StaffReportWithLoader />} />

          <Route path="/Feedback" element={<FeedbackWithLoader />} />

          <Route path="/Student-hub" element={<StudentHubWithLoader />} />

          <Route
            path="/Student-Report-Dashbord"
            element={<StudentReportDashWithLoader />}
          />

          <Route path="/profile" element={<ProfileWithLoader />} />

          <Route
            path="/FeeManagement"
            element={<FeeManagementWithLoader />}
          />

          <Route path="/PageResults" element={<PageResultsWithLoader />} />

          <Route path="/Attendance" element={<AttendanceWithLoader />} />

          <Route path="/Profileparent" element={<ProfileparentWithLoader />} />

          <Route path="/My-Children" element={<MyChildrenWithLoader />} />

          <Route path="/Student-Report" element={<StudentReportWithLoader />} />

          <Route path="/SchemeSearch" element={<SchemeSearchWithLoader />} />

          <Route path="/student-login" element={<LoginWithLoader />} />

          <Route path="/parent-login" element={<ParentloginWithLoader />} />

          <Route path="/register" element={<RegisterWithLoader />} />

          {/* ---------- 404 Page ---------- */}
          <Route
            path="*"
            element={
              <div
                style={{
                  minHeight: "60vh",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                  padding: "40px",
                  textAlign: "center",
                }}
              >
                <h1
                  style={{
                    fontSize: "64px",
                    margin: "0 0 10px",
                    fontWeight: "800",
                  }}
                >
                  404
                </h1>

                <p
                  style={{
                    fontSize: "18px",
                    margin: 0,
                  }}
                >
                  Page Not Found
                </p>
              </div>
            }
          />
        </Routes>
      </main>

      <Footer />
    </div>
  );
}

/* ---------------- App ---------------- */
function App() {
  return (
    <BrowserRouter>
      <Layout />
    </BrowserRouter>
  );
}

export default App;